import React from 'react'
import Breadcrub from '../Common/Breadcrub'

const About = () => {
  return (
    <>
       <Breadcrub title="About Us" />
       <section class="aboutus-style-02">
            <div class="container">
                <div class="row align-items-center mt-n1-9">                    
                    <div class="col-lg-12 col-xl-12 mt-1-9">                       
                        <h2 class="mb-1-6 dark-color">Welcome to Mahatma Gandhi Institute of Medical Sciences </h2>
                        <p>We are highly captivated to welcome you all in Mahatma Gandhi Institute of Medical Sciences (MGIMS), where education does not commence only with the 'Books'. Our aim is to impart all round quality education to the Students with a view to shape them into well rounded, well-adjusted and well-tuned Professionals, capable of making their future in various walks of life. We are designed to achieve efficient prefectural system in pharmacy for students.</p>
                        <p>MGIMS is established in the year 2022, is exclusively consecrated in the field of Pharmaceutical education and continuously generating Diploma in pharmacy graduates. It's also offering opportunities to contribute to the pharmaceutical industry right from licensed pharmacists to pharmaceutical scientists who develop the medications, actively involved in dosage form design, conduct research, recrudesce formulation and are administrators in the pharmaceutical industry.</p>
                       
                        <p>Gallant and aspirational, down-to-earth and friendly, we offer you a world-class learning experience that's bedded in a rich educational heritage at MGIMS. By choosing to study at the Mahatma Gandhi Institute of Medical Sciences you are investing in an education that will help you build a successful future. We will support your learning by providing an educational experience designed to help you unlock and explore your full potential.  </p>
                    </div>
                </div>

                <div class="row align-items-center mt-n1-9 mb-5">                    
                    <div class="col-lg-4 col-xl-4 mt-1-9">
                        <div class="instructor-img-wrapper mb-50 md-mb-0">
                            <div class="mb-1-6 mb-xl-1-9">
                                <img class="border-radius-5" src="img/content/vision-01.png" alt="..." />
                            </div>                                               
                        </div>
                    </div>

                    <div class="col-lg-8 col-xl-8 mt-1-9">    
                        <h3>Our Vision</h3>
                        <ul>
                            <li>To improve the intellectual capacity and desire for the ethical practice of Pharmacy.</li>
                            <li>To maintain high quality teaching-learning process to become leaders in education.</li>
                            <li>To organize frequent public health education and awareness programs in response to the societal needs.</li>
                            <li>To provide state-of-art infrastructure with modern laboratory facilities</li>
                            <li>To develop innovative pharmacy education modules and training programs.</li>
                            <li>To create a learner centered educational system to bring out inherent talents.</li>
                            <li>To acquire the best suitable ambiance for understanding the ethics in practice during education.</li>
                            <li>To device the best curriculum to understand the career objectives and etiquettes.</li>
                        </ul>
                    </div>
                </div>

                <div class="row align-items-center mt-n1-9 mb-5">                    
                    <div class="col-lg-4 col-xl-4 mt-1-9">
                        <div class="instructor-img-wrapper mb-50 md-mb-0">
                            <div class="mb-1-6 mb-xl-1-9">
                                <img class="border-radius-5" src="img/content/vision-02.png" alt="..." />
                            </div>                                               
                        </div>
                    </div>

                    <div class="col-lg-8 col-xl-8 mt-1-9"> 
                        <h3>Our Mission</h3>
                        <p>To impart exemplary Pharmacy Education to student pharmacists by inculcating the passion to learn the core of Pharmaceutical Science and Technology and creating prudent citizens to serve to the community by the knowledge, skill and attitude in different domains like Community Pharmacy, Hospital Pharmacy, Clinical Pharmacy, Industrial Pharmacy, Regulatory affairs, Management, Academia, Research and Development and to augment the Health Index of the country by adoring and honest service.</p>
                    </div>
                </div>
                <div class="row align-items-center mt-n1-9 mb-5">
                    <div class="col-lg-4 col-xl-4 mt-1-9">
                        <div class="instructor-img-wrapper mb-50 md-mb-0">
                            <div class="mb-1-6 mb-xl-1-9">
                                <img class="border-radius-5" src="img/content/vision-03.png" alt="..." />
                            </div>                                               
                        </div>
                    </div>
                    <div class="col-lg-8 col-xl-8 mt-1-9">      
                        <h3>Quality Policy</h3>
                        <p>Quality education is our motto and we are committed to quality excellence in our technical profession. </p>
                    </div>
                </div>
                <div class="shape20">
                    <img src="img/bg/bg-02.jpg" alt="..." />
                </div>
                <div class="shape18">
                    <img src="img/bg/bg-01.jpg" alt="..." />
                </div>
                <div class="shape21">
                    <img src="img/bg/bg-03.jpg" alt="..." />
                </div>
            </div>
        </section>

        
    </>
  )
}

export default About
